import type { GlobalStylesProps } from '@mui/material';

export const muiGlobalStyles: GlobalStylesProps['styles'] = {
  'html, body, #root': { height: '100%' },
  '.react-flow__attribution': { display: 'none' },
};
